<template>
  <div
    v-if="theme.page_banner_visible && theme.page_banner_background_image"
    id="company-banner"
    :style="style"
  />
</template>

<script>
export default {
  props: {
    company: { type: Object, required: true },
    theme: { type: Object },
  },
  data() {
    return {
      visible: false,
      config: undefined,
    };
  },
  computed: {
    style() {
      if (this.theme.page_banner_visible && this.theme.page_banner_background_image) {
        return {
          backgroundImage: `url(${this.theme.page_banner_background_image})`,
        };
      }
      return {};
    },
  },
  mounted() {
    //
  },
};
</script>

<style lang="scss" scoped>
#company-banner {
  width: auto;
  height: 180px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-top: -1rem;
}
</style>
